import {
    Input,
    Container,
    Row,
    Col,
    Form,
    FormGroup,
    Label,
} from "reactstrap";
import React, { useState } from 'react';
import { useHistory } from "react-router-dom";
import { login } from "./api/api";
import NavMenu from "./commons/NavMenu";
import NavMenuMobile from "./commons/NavMenuMobile";

const Login = (props) => {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [err, setErr] = useState("IDとパスワードを入力してください");
    const history = useHistory();

    const validInput = () => {
        let isValid = true;
        if (!username || !password) {
            isValid = false;
        }
        return isValid;
    };

    const handleLogin = async (e) => {
        e.preventDefault();
        if (validInput()) {
            const isAuthed = await login(username, password);
            //    .then((res) => {
            //         localStorage.setItem('username', username);
            //         localStorage.setItem('accessToken', res.data.data.id_token);
            //         props.setIsAuthed(true);
            //         history.push('/home');
            //     }).catch((e) => {
            //         setErr("間違ったユーザー名またはパスワード ");
            //         setTimeout(() => setErr("IDとパスワードを入力してください"), 5000);
            //     });
            if (isAuthed !== null) {
                props.setIsAuthed(true);
                history.push('/home');
            }
            else {
                setErr("間違ったユーザー名またはパスワード ");
                setTimeout(() => setErr("IDとパスワードを入力してください"), 5000);
            }
        }
    }



    return (
        <div className="outerPageNav">
            <NavMenu />
            <NavMenuMobile />
            <Container>
                <Row>
                    <Col md={5} className="p-md-5 p-3 mx-auto mt-5 base-shadow col-md-8 col-lg-5">
                        {/* {(err !== null) && <Alert color="danger">{err}</Alert>} */}
                        <Form id="login-form" onSubmit={handleLogin}>
                            {(err !== null) && <span className={err.includes("間違") ? "text-danger" : ""}>{err}</span>}
                            <FormGroup className="mt-5">
                                <Label for="username" >ユーザー名</Label>
                                <Input type="username" name="username" id="username" onChange={(e) => setUsername(e.target.value)} ></Input>

                            </FormGroup>
                            <FormGroup className="mt-4">
                                <Label for="password">パスワード</Label>
                                <Input type="password" name="password" id="password" onChange={(e) => setPassword(e.target.value)}></Input>

                            </FormGroup>
                            <Col className="p-0">
                                <button type="submit" className="btn btn__setting">ログイン</button>
                            </Col>
                        </Form>
                        {/* {(err !== null) && <Alert color="danger" className="position-absolute">{err}</Alert>} */}
                    </Col>
                </Row>
            </Container>
        </div >
    );
}

export default Login;